/*
 * Copyright (c) 2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

// This file is autogenerated by this script: packages/cp-shared-ui/scripts/populate-countries-cities-json.ts.
import { Timezones } from '../../models/zones'
export const TIMEZONES: Timezones = {
  AF: ['UTC+04:30 (Afghanistan Time)'],
  AX: ['UTC+02:00 (Eastern European Time)'],
  AL: ['UTC+01:00 (Central European Time)'],
  DZ: ['UTC+01:00 (Central European Time)'],
  AS: ['UTC-11:00 (Samoa Standard Time)'],
  AD: ['UTC+01:00 (Central European Time)'],
  AO: ['UTC+01:00 (West Africa Time)'],
  AI: ['UTC-04:00 (Atlantic Standard Time)'],
  AQ: [
    'UTC-03:00 (Chile Summer Time)',
    'UTC-03:00 (Rothera Research Station Time)',
    'UTC±00 (Greenwich Mean Time)',
    'UTC+03:00 (Showa Station Time)',
    'UTC+05:00 (Mawson Station Time)',
    'UTC+06:00 (Vostok Station Time)',
    'UTC+07:00 (Davis Time)',
    "UTC+10:00 (Dumont d'Urville Time)",
    'UTC+11:00 (Australian Western Standard Time)',
    'UTC+13:00 (New Zealand Daylight Time)'
  ],
  AG: ['UTC-04:00 (Atlantic Standard Time)'],
  AR: ['UTC-03:00 (Argentina Time)'],
  AM: ['UTC+04:00 (Armenia Time)'],
  AW: ['UTC-04:00 (Atlantic Standard Time)'],
  AU: [
    'UTC+08:00 (Australian Western Standard Time)',
    'UTC+08:45 (Australian Central Western Standard Time (Unofficial))',
    'UTC+09:30 (Australian Central Standard Time)',
    'UTC+10:00 (Australian Eastern Standard Time)',
    'UTC+10:30 (Australian Central Daylight Saving Time)',
    'UTC+11:00 (Macquarie Island Station Time)',
    'UTC+11:00 (Australian Eastern Daylight Saving Time)',
    'UTC+11:00 (Lord Howe Summer Time)'
  ],
  AT: ['UTC+01:00 (Central European Time)'],
  AZ: ['UTC+04:00 (Azerbaijan Time)'],
  BH: ['UTC+03:00 (Arabia Standard Time)'],
  BD: ['UTC+06:00 (Bangladesh Standard Time)'],
  BB: ['UTC-04:00 (Atlantic Standard Time)'],
  BY: ['UTC+03:00 (Moscow Time)'],
  BE: ['UTC+01:00 (Central European Time)'],
  BZ: ['UTC-06:00 (Central Standard Time (North America))'],
  BJ: ['UTC+01:00 (West Africa Time)'],
  BM: ['UTC-04:00 (Atlantic Standard Time)'],
  BT: ['UTC+06:00 (Bhutan Time)'],
  BO: ['UTC-04:00 (Bolivia Time)'],
  BQ: ['UTC-04:00 (Atlantic Standard Time)'],
  BA: ['UTC+01:00 (Central European Time)'],
  BW: ['UTC+02:00 (Central Africa Time)'],
  BV: ['UTC+01:00 (Central European Time)'],
  BR: [
    'UTC-05:00 (Acre Time)',
    'UTC-04:00 (Amazon Time (Brazil)[3)',
    'UTC-04:00 (Brasilia Time)',
    'UTC-04:00 (Amazon Time (Brazil))',
    'UTC-03:00 (Brasília Time)',
    'UTC-02:00 (Fernando de Noronha Time)'
  ],
  IO: ['UTC+06:00 (Indian Ocean Time)'],
  BN: ['UTC+08:00 (Brunei Darussalam Time)'],
  BG: ['UTC+02:00 (Eastern European Time)'],
  BF: ['UTC±00 (Greenwich Mean Time)'],
  BI: ['UTC+02:00 (Central Africa Time)'],
  KH: ['UTC+07:00 (Indochina Time)'],
  CM: ['UTC+01:00 (West Africa Time)'],
  CA: [
    'UTC-08:00 (Pacific Standard Time (North America)',
    'UTC-07:00 (Mountain Standard Time (North America))',
    'UTC-07:00 (Mountain Standard Time (North America)',
    'UTC-06:00 (Central Standard Time (North America)',
    'UTC-05:00 (Eastern Standard Time (North America))',
    'UTC-05:00 (Eastern Standard Time (North America)',
    'UTC-04:00 (Atlantic Standard Time)',
    'UTC-03:30 (Newfoundland Standard Time)'
  ],
  CV: ['UTC-01:00 (Cape Verde Time)'],
  KY: ['UTC-05:00 (Eastern Standard Time (North America)'],
  CF: ['UTC+01:00 (West Africa Time)'],
  TD: ['UTC+01:00 (West Africa Time)'],
  CL: ['UTC-05:00 (Easter Island Summer Time)', 'UTC-03:00 (Chile Summer Time)'],
  CN: ['UTC+06:00 (China Standard Time)', 'UTC+08:00 (China Standard Time)'],
  CX: ['UTC+07:00 (Christmas Island Time)'],
  CC: ['UTC+06:30 (Cocos Islands Time)'],
  CO: ['UTC-05:00 (Colombia Time)'],
  KM: ['UTC+03:00 (East Africa Time)'],
  CG: ['UTC+01:00 (West Africa Time)'],
  CK: ['UTC-10:00 (Cook Island Time)'],
  CR: ['UTC-06:00 (Central Standard Time (North America)'],
  HR: ['UTC+01:00 (Central European Time)'],
  CU: ['UTC-05:00 (Cuba Standard Time)'],
  CW: ['UTC-04:00 (Atlantic Standard Time)'],
  CY: ['UTC+02:00 (Eastern European Time)'],
  CZ: ['UTC+01:00 (Central European Time)'],
  CD: ['UTC+01:00 (West Africa Time)', 'UTC+02:00 (Central Africa Time)'],
  DK: ['UTC+01:00 (Central European Time)'],
  DJ: ['UTC+03:00 (East Africa Time)'],
  DM: ['UTC-04:00 (Atlantic Standard Time)'],
  DO: ['UTC-04:00 (Atlantic Standard Time)'],
  EC: ['UTC-06:00 (Galápagos Time)', 'UTC-05:00 (Ecuador Time)'],
  EG: ['UTC+02:00 (Eastern European Time)'],
  SV: ['UTC-06:00 (Central Standard Time (North America)'],
  GQ: ['UTC+01:00 (West Africa Time)'],
  ER: ['UTC+03:00 (East Africa Time)'],
  EE: ['UTC+02:00 (Eastern European Time)'],
  SZ: ['UTC+02:00 (South African Standard Time)'],
  ET: ['UTC+03:00 (East Africa Time)'],
  FK: ['UTC-03:00 (Falkland Islands Summer Time)'],
  FO: ['UTC±00 (Western European Time)'],
  FJ: ['UTC+12:00 (Fiji Time)'],
  FI: ['UTC+02:00 (Eastern European Time)'],
  FR: ['UTC+01:00 (Central European Time)'],
  GF: ['UTC-03:00 (French Guiana Time)'],
  PF: ['UTC-10:00 (Tahiti Time)', 'UTC-09:30 (Marquesas Islands Time)', 'UTC-09:00 (Gambier Islands Time)'],
  TF: ['UTC+05:00 (French Southern and Antarctic Time)'],
  GA: ['UTC+01:00 (West Africa Time)'],
  GE: ['UTC+04:00 (Georgia Standard Time)'],
  DE: ['UTC+01:00 (Central European Time)'],
  GH: ['UTC±00 (Greenwich Mean Time)'],
  GI: ['UTC+01:00 (Central European Time)'],
  GR: ['UTC+02:00 (Eastern European Time)'],
  GL: [
    'UTC-04:00 (Atlantic Standard Time)',
    'UTC-03:00 (West Greenland Time)',
    'UTC-01:00 (Eastern Greenland Time)',
    'UTC±00 (Greenwich Mean Time)'
  ],
  GD: ['UTC-04:00 (Atlantic Standard Time)'],
  GP: ['UTC-04:00 (Atlantic Standard Time)'],
  GU: ['UTC+10:00 (Chamorro Standard Time)'],
  GT: ['UTC-06:00 (Central Standard Time (North America)'],
  GG: ['UTC±00 (Greenwich Mean Time)'],
  GN: ['UTC±00 (Greenwich Mean Time)'],
  GW: ['UTC±00 (Greenwich Mean Time)'],
  GY: ['UTC-04:00 (Guyana Time)'],
  HT: ['UTC-05:00 (Eastern Standard Time (North America)'],
  HM: ['UTC+05:00 (French Southern and Antarctic Time)'],
  HN: ['UTC-06:00 (Central Standard Time (North America)'],
  HK: ['UTC+08:00 (Hong Kong Time)'],
  HU: ['UTC+01:00 (Central European Time)'],
  IS: ['UTC±00 (Greenwich Mean Time)'],
  IN: ['UTC+05:30 (Indian Standard Time)'],
  ID: ['UTC+07:00 (Western Indonesian Time)', 'UTC+08:00 (Central Indonesia Time)', 'UTC+09:00 (Eastern Indonesian Time)'],
  IR: ['UTC+03:30 (Iran Daylight Time)'],
  IQ: ['UTC+03:00 (Arabia Standard Time)'],
  IE: ['UTC±00 (Greenwich Mean Time)'],
  IL: ['UTC+02:00 (Israel Standard Time)'],
  IT: ['UTC+01:00 (Central European Time)'],
  CI: ['UTC±00 (Greenwich Mean Time)'],
  JM: ['UTC-05:00 (Eastern Standard Time (North America)'],
  JP: ['UTC+09:00 (Japan Standard Time)'],
  JE: ['UTC±00 (Greenwich Mean Time)'],
  JO: ['UTC+02:00 (Eastern European Time)'],
  KZ: [
    'UTC+05:00 (Aqtobe Time)',
    'UTC+05:00 (Moscow Daylight Time+1)',
    'UTC+05:00 (Oral Time)',
    'UTC+05:00 (Qyzylorda Summer Time)',
    'UTC+06:00 (Alma-Ata Time[1)',
    'UTC+06:00 (Qyzylorda Summer Time)'
  ],
  KE: ['UTC+03:00 (East Africa Time)'],
  KI: ['UTC+12:00 (Gilbert Island Time)', 'UTC+13:00 (Phoenix Island Time)', 'UTC+14:00 (Line Islands Time)'],
  XK: ['UTC+01:00 (Central European Time)'],
  KW: ['UTC+03:00 (Arabia Standard Time)'],
  KG: ['UTC+06:00 (Kyrgyzstan Time)'],
  LA: ['UTC+07:00 (Indochina Time)'],
  LV: ['UTC+02:00 (Eastern European Time)'],
  LB: ['UTC+02:00 (Eastern European Time)'],
  LS: ['UTC+02:00 (South African Standard Time)'],
  LR: ['UTC±00 (Greenwich Mean Time)'],
  LY: ['UTC+02:00 (Eastern European Time)'],
  LI: ['UTC+01:00 (Central European Time)'],
  LT: ['UTC+02:00 (Eastern European Time)'],
  LU: ['UTC+01:00 (Central European Time)'],
  MO: ['UTC+08:00 (China Standard Time)'],
  MG: ['UTC+03:00 (East Africa Time)'],
  MW: ['UTC+02:00 (Central Africa Time)'],
  MY: ['UTC+08:00 (Malaysia Time)'],
  MV: ['UTC+05:00 (Maldives Time)'],
  ML: ['UTC±00 (Greenwich Mean Time)'],
  MT: ['UTC+01:00 (Central European Time)'],
  IM: ['UTC±00 (Greenwich Mean Time)'],
  MH: ['UTC+12:00 (Marshall Islands Time)'],
  MQ: ['UTC-04:00 (Atlantic Standard Time)'],
  MR: ['UTC±00 (Greenwich Mean Time)'],
  MU: ['UTC+04:00 (Mauritius Time)'],
  YT: ['UTC+03:00 (East Africa Time)'],
  MX: [
    'UTC-08:00 (Pacific Standard Time (North America)',
    'UTC-07:00 (Mountain Standard Time (North America)',
    'UTC-06:00 (Central Standard Time (North America)',
    'UTC-05:00 (Eastern Standard Time (North America)'
  ],
  FM: ['UTC+10:00 (Chuuk Time)', 'UTC+11:00 (Kosrae Time)', 'UTC+11:00 (Pohnpei Standard Time)'],
  MD: ['UTC+02:00 (Eastern European Time)'],
  MC: ['UTC+01:00 (Central European Time)'],
  MN: ['UTC+07:00 (Hovd Time)', 'UTC+08:00 (Choibalsan Standard Time)', 'UTC+08:00 (Ulaanbaatar Standard Time)'],
  ME: ['UTC+01:00 (Central European Time)'],
  MS: ['UTC-04:00 (Atlantic Standard Time)'],
  MA: ['UTC+01:00 (Western European Summer Time)', 'UTC+01:00 (Western Sahara Time)'],
  MZ: ['UTC+02:00 (Central Africa Time)'],
  MM: ['UTC+06:30 (Myanmar Standard Time)'],
  NA: ['UTC+02:00 (West Africa Summer Time)'],
  NR: ['UTC+12:00 (Nauru Time)'],
  NP: ['UTC+05:45 (Nepal Time)'],
  NL: ['UTC+01:00 (Central European Time)'],
  NC: ['UTC+11:00 (New Caledonia Time)'],
  NZ: ['UTC+13:00 (New Zealand Daylight Time)', 'UTC+13:45 (Chatham Standard Time)'],
  NI: ['UTC-06:00 (Central Standard Time (North America)'],
  NE: ['UTC+01:00 (West Africa Time)'],
  NG: ['UTC+01:00 (West Africa Time)'],
  NU: ['UTC-11:00 (Niue Time)'],
  NF: ['UTC+12:00 (Norfolk Time)'],
  KP: ['UTC+09:00 (Korea Standard Time)'],
  MK: ['UTC+01:00 (Central European Time)'],
  MP: ['UTC+10:00 (Chamorro Standard Time)'],
  NO: ['UTC+01:00 (Central European Time)'],
  OM: ['UTC+04:00 (Gulf Standard Time)'],
  PK: ['UTC+05:00 (Pakistan Standard Time)'],
  PW: ['UTC+09:00 (Palau Time)'],
  PS: ['UTC+02:00 (Eastern European Time)'],
  PA: ['UTC-05:00 (Eastern Standard Time (North America)'],
  PG: ['UTC+10:00 (Papua New Guinea Time)', 'UTC+11:00 (Bougainville Standard Time[6)'],
  PY: ['UTC-03:00 (Paraguay Summer Time)'],
  PE: ['UTC-05:00 (Peru Time)'],
  PH: ['UTC+08:00 (Philippine Time)'],
  PN: ['UTC-08:00 (Pacific Standard Time (North America)'],
  PL: ['UTC+01:00 (Central European Time)'],
  PT: ['UTC-01:00 (Azores Standard Time)', 'UTC±00 (Western European Time)'],
  PR: ['UTC-04:00 (Atlantic Standard Time)'],
  QA: ['UTC+03:00 (Arabia Standard Time)'],
  RE: ['UTC+04:00 (Réunion Time)'],
  RO: ['UTC+02:00 (Eastern European Time)'],
  RU: [
    'UTC+02:00 (Eastern European Time)',
    'UTC+03:00 (Moscow Time)',
    'UTC+04:00 (Samara Time)',
    'UTC+04:00 (Moscow Daylight Time+4)',
    'UTC+04:00 (Moscow Standard Time)',
    'UTC+05:00 (Yekaterinburg Time)',
    'UTC+06:00 (Omsk Time)',
    'UTC+07:00 (Krasnoyarsk Time)',
    'UTC+07:00 (Novosibirsk Time)',
    'UTC+07:00 (Moscow Daylight Time+3)',
    'UTC+08:00 (Irkutsk Time)',
    'UTC+09:00 (Yakutsk Time)',
    'UTC+10:00 (Vladivostok Time)',
    'UTC+11:00 (Magadan Time)',
    'UTC+11:00 (Sakhalin Island Time)',
    'UTC+11:00 (Srednekolymsk Time)',
    'UTC+12:00 (Anadyr Time[4)',
    'UTC+12:00 (Kamchatka Time)'
  ],
  RW: ['UTC+02:00 (Central Africa Time)'],
  SH: ['UTC±00 (Greenwich Mean Time)'],
  KN: ['UTC-04:00 (Atlantic Standard Time)'],
  LC: ['UTC-04:00 (Atlantic Standard Time)'],
  PM: ['UTC-03:00 (Pierre & Miquelon Daylight Time)'],
  VC: ['UTC-04:00 (Atlantic Standard Time)'],
  BL: ['UTC-04:00 (Atlantic Standard Time)'],
  MF: ['UTC-04:00 (Atlantic Standard Time)'],
  WS: ['UTC+14:00 (West Samoa Time)'],
  SM: ['UTC+01:00 (Central European Time)'],
  ST: ['UTC±00 (Greenwich Mean Time)'],
  SA: ['UTC+03:00 (Arabia Standard Time)'],
  SN: ['UTC±00 (Greenwich Mean Time)'],
  RS: ['UTC+01:00 (Central European Time)'],
  SC: ['UTC+04:00 (Seychelles Time)'],
  SL: ['UTC±00 (Greenwich Mean Time)'],
  SG: ['UTC+08:00 (Singapore Time)'],
  SX: ['UTC-04:00 (Atlantic Standard Time)'],
  SK: ['UTC+01:00 (Central European Time)'],
  SI: ['UTC+01:00 (Central European Time)'],
  SB: ['UTC+11:00 (Solomon Islands Time)'],
  SO: ['UTC+03:00 (East Africa Time)'],
  ZA: ['UTC+02:00 (South African Standard Time)'],
  GS: ['UTC-02:00 (South Georgia and the South Sandwich Islands Time)'],
  KR: ['UTC+09:00 (Korea Standard Time)'],
  SS: ['UTC+03:00 (East Africa Time)'],
  ES: ['UTC±00 (Western European Time)', 'UTC+01:00 (Central European Time)'],
  LK: ['UTC+05:30 (Indian Standard Time)'],
  SD: ['UTC+02:00 (Eastern African Time)'],
  SR: ['UTC-03:00 (Suriname Time)'],
  SJ: ['UTC+01:00 (Central European Time)'],
  SE: ['UTC+01:00 (Central European Time)'],
  CH: ['UTC+01:00 (Central European Time)'],
  SY: ['UTC+02:00 (Eastern European Time)'],
  TW: ['UTC+08:00 (China Standard Time)'],
  TJ: ['UTC+05:00 (Tajikistan Time)'],
  TZ: ['UTC+03:00 (East Africa Time)'],
  TH: ['UTC+07:00 (Indochina Time)'],
  BS: ['UTC-05:00 (Eastern Standard Time (North America))'],
  GM: ['UTC±00 (Greenwich Mean Time)'],
  TL: ['UTC+09:00 (Timor Leste Time)'],
  TG: ['UTC±00 (Greenwich Mean Time)'],
  TK: ['UTC+13:00 (Tokelau Time)'],
  TO: ['UTC+13:00 (Tonga Time)'],
  TT: ['UTC-04:00 (Atlantic Standard Time)'],
  TN: ['UTC+01:00 (Central European Time)'],
  TR: ['UTC+03:00 (Eastern European Time)'],
  TM: ['UTC+05:00 (Turkmenistan Time)'],
  TC: ['UTC-05:00 (Eastern Standard Time (North America)'],
  TV: ['UTC+12:00 (Tuvalu Time)'],
  UG: ['UTC+03:00 (East Africa Time)'],
  UA: ['UTC+02:00 (Eastern European Time)', 'UTC+03:00 (Moscow Time)'],
  AE: ['UTC+04:00 (Gulf Standard Time)'],
  GB: ['UTC±00 (Greenwich Mean Time)'],
  US: [
    'UTC-10:00 (Hawaii–Aleutian Standard Time)',
    'UTC-09:00 (Alaska Standard Time)',
    'UTC-08:00 (Pacific Standard Time (North America)',
    'UTC-07:00 (Mountain Standard Time (North America)',
    'UTC-06:00 (Central Standard Time (North America)',
    'UTC-05:00 (Eastern Standard Time (North America)'
  ],
  UM: ['UTC-11:00 (Samoa Standard Time)', 'UTC+12:00 (Wake Island Time)'],
  UY: ['UTC-03:00 (Uruguay Standard Time)'],
  UZ: ['UTC+05:00 (Uzbekistan Time)'],
  VU: ['UTC+11:00 (Vanuatu Time)'],
  VA: ['UTC+01:00 (Central European Time)'],
  VE: ['UTC-04:00 (Venezuelan Standard Time)'],
  VN: ['UTC+07:00 (Indochina Time)'],
  VG: ['UTC-04:00 (Atlantic Standard Time)'],
  VI: ['UTC-04:00 (Atlantic Standard Time)'],
  WF: ['UTC+12:00 (Wallis & Futuna Time)'],
  EH: ['UTC+01:00 (Western European Summer Time)'],
  YE: ['UTC+03:00 (Arabia Standard Time)'],
  ZM: ['UTC+02:00 (Central Africa Time)'],
  ZW: ['UTC+02:00 (Central Africa Time)']
}
